import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Pagination from 'brastrap/common/pagination/Pagination';

const PAGE_PLACEHOLDER = '{page}';

const mapStateToProps = ({
  app: {
    serverAndPort,
    routing: { hash, pathname, query },
  },
  browser: {
    deviceIs: { mobile },
  },
}) => ({
  hash,
  serverAndPort,
  pathname,
  query,
  isMobile: mobile,
});

const generateHref = ({ hash, pathname, query, serverAndPort }) => {
  const queryParams = [
    ...Object.keys(query)
      // Remove any existing page param as we will replace it below.
      .filter(key => key !== 'page')
      .map(key => `${key}=${query[key]}`),
    `page=${PAGE_PLACEHOLDER}`,
  ];
  return `${serverAndPort}${pathname}?${queryParams.join('&')}${hash}`;
};

const WrappedPagination = props => {
  const href = generateHref(props);
  const paginationProps = { ...props, href };
  if (props.isMobile) {
    paginationProps.maxItems = 1;
  }
  return (
    <div>
      <Pagination {...paginationProps} />
    </div>
  );
};

WrappedPagination.propTypes = {
  hash: PropTypes.string,
  url: PropTypes.string,
  total: PropTypes.number,
  serverAndPort: PropTypes.string,
  query: PropTypes.object,
  pathname: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default connect(mapStateToProps)(WrappedPagination);
